<template>
    <ModalOverlay v-model="visible">
        <template v-slot:activator="{ on }">
            <div class="row g-0">
                <div class="col" style="padding: 0">
                    <button class="btn btn-secondary btn-block" id="activator" type="button"  v-on="on">
                        <i class="fas fa-sliders-h"></i> {{ $t('components.search.mini.preferences') }}
                    </button>
                </div>
            </div>
        </template>
        <template v-slot:header>
            <div class="row">
                <div class="col" style="padding: 0">
                    <h3 class="title"> <i class="fas fa-sliders-h"></i>  {{ $t('components.search.mini.preferences') }}</h3>
                </div>
            </div>
        </template>
        <template v-slot:content>

            <div class="container">

            <div class="row">
                <div class="col">
                    <DatePicker></DatePicker>
                </div>
            </div>

            <div class="row">
                <div class="col">
                    <hr class="solid">
                </div>
            </div>

            <div class="row">
                <div class="col">
                    <OccupantsStepper></OccupantsStepper>
                </div>
            </div>

            <div class="row">
                <div class="col">
                    <hr class="solid">
                </div>
            </div>

            <div class="row">
                <div class="col">
                    <RegionToggles :controls="true"></RegionToggles>
                </div>
            </div>

            <div class="row">
                <div class="col">
                    <hr class="solid">
                </div>
            </div>

            <div class="row">
                <div class="col">
                    <HouseTypesToggles :controls="true"/>
                </div>
            </div>

            <div class="row">
                <div class="col">
                    <hr class="solid">
                </div>
            </div>

            <div class="row">
                <div class="col">
                    <PropertiesToggles :controls="true"></PropertiesToggles>
                </div>
            </div>

            </div>
        </template>

        <template v-slot:footer>
            <button class="btn btn-primary btn-block" @click="showResults">{{ $t('components.search.common.search') }}</button>
        </template>
    </ModalOverlay>
</template>

<script>
import ModalOverlay from "@/components/common/ModalOverlay"
import ToggleGroup from "@/components/common/ToggleGroup"
import OccupantsStepper from "@/components/search/OccupantsStepper"
import RegionToggles from "@/components/search/RegionToggles"
import PropertiesToggles from "@/components/search/PropertiesToggles"
import HouseTypesToggles from "@/components/search/HouseTypesToggles"
import DatePicker from "@/components/search/DatePicker"
export default {
    name: "MiniSearchWidget",
    components: {
        ModalOverlay,
        ToggleGroup,
        OccupantsStepper,
        RegionToggles,
        PropertiesToggles,
        HouseTypesToggles,
        DatePicker
    },
    computed: {
        query: function() {
            return this.$store.getters.getQuery;
        },
        houseTypes: {
            get() {
                let types = this.$store.getters.getHouseTypes;
                let locale = this.$i18n.locale;
                
                if (types === undefined) {
                    return [];
                }

                return types;
            },
            set(val) {
                this.$store.commit('setHouseTypes', val);
            }
        },
        properties: {
            get() {
                return this.$store.getters.getProperties;
            },
            set(val) {
                this.$store.commit('setProperties', val);
            }
        },
        regions: {
            get() {
                let reg = this.$store.getters.getRegions;
                
                if (reg === undefined) {
                    return [];
                }

                return reg;
            },
            set(val) {
                this.$store.commit('setRegions', val);
            }
        },
        selectedDates: {
            get() {
                return this.query.selectedDates;
            },
            set(val) {
                console.log(val)
                // this.query.selectedDates = val;
                let query = this.query;
                query.selectedDates = val;
                this.$store.commit('setQuery', query)
            }
        },
        
    },
    methods: {
        showResults: function() {
            this.visible = false;
            this.$emit('search');
        }
    },
    data() {
        return {
            visible: false
        }
    }
}
</script>

<style lang="scss" scoped>
    .title {
        margin: 0;
        width: 100%;
        text-align: center;
    }

    .btn {
        border-radius: $button-border-radius
    }

    #activator {
        line-height: 30px;
        font-size: 16px;;
    }

    .fas.fa-sliders-h {
        color: $white;
    }
</style>